type ServerClock = {checkedAt:string};
type Sample = {server:number;received:number};
const samples=new Map<string,Sample>();

function sample(worker?:ServerClock):Sample|undefined{
 const key=worker?.checkedAt;
 if(!key)return;
 const existing=samples.get(key);
 if(existing)return existing;
 const server=Date.parse(key);
 if(!Number.isFinite(server))return;
 const value={server,received:performance.now()};
 samples.set(key,value);
 // Cover the short-lived query cache without retaining every polling response.
 if(samples.size>256)samples.delete(samples.keys().next().value!);
 return value;
}

/** Record receipt before a response enters the query cache, not at component mount. */
export function recordGenerationClock(payload:unknown):void{
 if(!payload||typeof payload!=='object')return;
 const worker=(payload as {generationWorker?:unknown}).generationWorker;
 if(worker&&typeof worker==='object'&&typeof (worker as ServerClock).checkedAt==='string')sample(worker as ServerClock);
}

/** Cached responses keep advancing through remounts, independently of device-clock skew. */
export function generationNow(worker?:ServerClock):number{
 const value=sample(worker);
 return value?value.server+Math.max(0,performance.now()-value.received):Date.now();
}
